export default class CustomResponse<T> {
  message: string;
  error: string;
  status: number;
  path: string;
  response: T;

  constructor() {}
}
